import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import echarts from 'echarts'
import 'echarts-wordcloud/dist/echarts-wordcloud.js'
import 'echarts-wordcloud/dist/echarts-wordcloud.min.js'
import jquery from 'jquery'
import 'echarts/map/js/province/neimenggu'
import 'echarts-gl'
import axios from 'axios';
import Home from './components/Index.vue';
import Zhi from './components/zhi.vue'
import Zhihui from './components/zhihui.vue'
import Hhht from './components/hhht.vue'
import Liu from './components/liu.vue'
import Yuan from './components/yuan.vue'
import Yin from './components/yin.vue'
import CZ from './components/cz.vue'
import Login from './components/login.vue'
import uav from './components/uav.vue'
import VueRouter from "vue-router"
//引入iconfont矢量图标
import './assets/icon/iconfont.css';
//highcharts的引入
// import VueHighcharts from 'vue-highcharts';
 
// Vue.use(VueHighcharts);

// 视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts;
Vue.prototype.$jquery = jquery;
Vue.prototype.$axios = axios;

const router = new VueRouter({
  routes: [
    // 动态路径参数 以冒号开头
    { path: '/home', component: Home },
    { path: '/zhihui', component: Zhihui },
    { path: '/Zhi', component: Zhi },
    { path: '/hhht', component: Hhht },
    { path: '/yuan', component: Yuan },
    { path: '/liu', component: Liu },
    { path: '/yin', component: Yin },
    { path: '/cz', component: CZ },
    { path: '/login', component: Login },
    { path: '/uav', component: uav },
  ]
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
